import React , { ReactElement, useState } from 'react';
import Link from 'next/link';
import LinesEllipsis from 'react-lines-ellipsis/lib/loose';
import { Picture, ISrcSet } from '@kursk/components/ui/Picture/Picture';
import styles from './PlaceCard.module.scss';
import { IPlace } from "@common/redux/types/places";
import { getPriceTitle } from '@kursk/utils/getPriceTitle';
import classNames from "classnames";

interface IPlaceCardProps {
  place: IPlace;
  type?: 'small' | 'medium' | 'large';
}

export function PlaceCard({ place, type = 'small' }: IPlaceCardProps): ReactElement {
  const [isHover, setIsHover] = useState(false);

  const imgSrcSet: ISrcSet[] = [
    {
      media: '(min-width: 0px)',
      width: type === 'small' ? 270 : type === 'medium' ? 580 : 1200,
      height: 241,
      cropMode: type === 'small' ? 'noCrop' : 'fromTop',
    }
  ];

  return (
    <Link href={`/places/${place._id}/${place.sysName}`}>
      <a>
        <div
          className={
            classNames(
              styles.wrapper,
              type === 'medium' && styles.mediumType,
              type === 'large' && styles.largeType
            )
          }
          onMouseOver={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
          <div className={styles.badge}>{place.category?.name}</div>
          <Picture className={styles.image} srcSet={imgSrcSet} image={place.image} />
          <div className={
            classNames(
              styles.info,
              type === 'medium' && styles.mediumTypeInfo,
              type === 'large' && styles.largeTypeInfo
            )
          }>
            <LinesEllipsis
              text={place.name}
              maxLine={isHover ? 4 : 3}
              ellipsis='...'
              trimRight
              basedOn='letters'
              className={styles.title}
            />
            {(place.ticketsInfo.available > 0 || place.ticketsInfo.unlimited) && (
              <p className={styles.price}>
                {
                  getPriceTitle(place.ticketsInfo.minPrice, place.ticketsInfo.maxPrice)
                }
              </p>
            )}
          </div>
        </div>
      </a>
    </Link>
  );
}
